/* eslint-disable import/prefer-default-export */
import {
  watchRequestPaymentData,
} from './signing';

export const signing = [
  watchRequestPaymentData,
];
